import React, { useState } from "react";
import './Footer.scss';
import twitter from '../../assets/twitter.svg'
import telegram from '../../assets/telegram.svg'
import youtube from '../../assets/youtube.svg'
import facebook from '../../assets/facebookicon.svg'
import insta from '../../assets/instagram.svg'
import { Link } from 'react-scroll';
import { Link as RouterLink } from 'react-router-dom';
import Pdf from '../../assets/Uniwallet Pay - WP.pdf'
import dotIcon from '../../assets/doticon.svg'
import tiktok from '../../assets/tiktok.svg'
import { Email, TelePhone } from "../../assets/StoreAsset/StoreAssets";
const Footer = ({ onClick }) => {
  const [activeSection, setActiveSection] = useState('home');
  const handleSetActive = (to) => {
    setActiveSection(to);
  };
  const homesec = [
    { to: "home", label: "Home" },
    { to: "about", label: "About Us" },
    { to: "feature", label: "Features" },
    { to: "token", label: "UWPS Token" },
  ];
  const cryptosec = [
    { to: "card", label: "Crypto Card" },
    { to: "roadmap", label: "Roadmap" },
    { to: "faq", label: "FAQs" },
    { to: "contact", label: "Contact" },
  ]
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-row">
          <div className="footer-col">
            <h4>Links</h4>
            <div className="footer-col_inner">
              <ul>
                <li>
                  {homesec.map((section) => (
                    <Link onClick={onClick}
                      key={section.to}
                      to={section.to}
                      spy={true}
                      smooth={true}
                      duration={500}
                      onSetActive={handleSetActive}
                      className={activeSection === section.to ? "active" : ""}
                    >
                      {section.label}
                    </Link>
                  ))}
                </li>
              </ul>
              <ul>
                <li>
                  {cryptosec.map((section) => (
                    <Link onClick={onClick}
                      key={section.to}
                      to={section.to}
                      spy={true}
                      smooth={true}
                      duration={500}
                      onSetActive={handleSetActive}
                      className={activeSection === section.to ? "active" : ""}
                    >
                      {section.label}
                    </Link>
                  ))}
                </li>
              </ul>
              <ul>
                <li>
                  <RouterLink to={Pdf} target="_blank">Whitepaper</RouterLink>
                  <RouterLink to="/privacy-policy" target="_blank">Privacy Policy</RouterLink>
                </li>
              </ul>
            </div>
          </div>
          <div className="footer-col">
            <h4>Contact</h4>
            <ul className="telephoneMail">
              <li> <a href="tel:+37052171012">
                <TelePhone /> +370 (5) 217 1012
              </a></li>
              <li>
                <a
                  href={`https://mail.google.com/mail/?view=cm&to=${'info@uniwalletpay.com'}`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  info@uniwalletpay.com
                </a>
              </li>
            </ul>
          </div>
          <div className="footer-col">
            <h4>Follow us</h4>
            <div className="social-icons">
              <div className="social-icons_inner">
                <a href="https://x.com/uniwalletpay" target={"_blank"}> <img src={twitter} alt='imgs' /></a>
                <a href="https://t.me/uniwallet_pay" target={"_blank"}><img src={telegram} alt='imgs' /></a>
                <a href="https://www.facebook.com/uniwalletpay" target={"_blank"}><img src={facebook} alt='imgs' /></a>
              </div>
              <div className="social-icons_inner">
                <a href="https://www.instagram.com/uniwalletpay/" target={"_blank"}><img src={insta} alt='imgs' /></a>
                <a href="https://medium.com/@uniwalletpay" target={"_blank"}><img src={dotIcon} alt='imgs' /></a>
                <a href="https://www.tiktok.com/@uniwalletpay" target={"_blank"}><img src={tiktok} alt='imgs' /></a>
              </div>
              <div className="social-icons_inner">
                <a href="https://www.youtube.com/@uniwalletpay" target={"_blank"}><img src={youtube} alt='imgs' /></a>
              </div>
            </div>
          </div>
        </div>
        <div className="footer-bottom">
          © 2025 UniWallet Pay Pay. All rights reserved
        </div>
      </div>
    </footer>

  );
};

export default Footer;
